import React from "react";
import { graphql } from "gatsby";

import Carousel from "components/Carousel";

import Quote from "components/Quote";

import * as styles from "./SectionTestimonials.module.less";

/**
 * We use this to define what will be queried for this component
 * This also serves as typings (See `Gatsby.SectionTestimonialsDataFragment` below)
 */
export const SectionTestimonialsDataFragment = graphql`
  fragment SectionTestimonialsData on MarkdownRemarkFrontmatterSections {
    quotes {
      ...TestimonialData
    }
    section_id
  }
`;

/**
 * @param {GatsbyTypes.SectionTestimonialsDataFragment} props
 */
export default function SectionTestimonials({ section_id, quotes = [] }) {
  return (
    <section id={section_id} className={styles.testimonials}>
      <Carousel>
        {quotes.map((quote, index) => (
          <Quote key={`${section_id}-${index}`} align="center" {...quote} />
        ))}
      </Carousel>
    </section>
  );
}
